'use strict';

var TemplatePreviewDirective = function TemplatePreviewDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/template-preview.html'),
    controller: 'TemplatePreviewController',
    scope: {
      strategyTemplate: '=',
      closePanelHandler: '&'
    }
  };
};
TemplatePreviewDirective.$inject = [];
module.exports = TemplatePreviewDirective;